import React, { useState, useEffect } from "react";
import { API_URL } from "../../../constants/index";
import { useDispatch } from "react-redux";
import moment from "moment";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../services/serviceCaller";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";

const CompOffStatement = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const [compOffStatement, setCompOffStatement] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [respStatus, setRepStatus] = useState(0);
  const [empList, setEmpList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [managerList, setManagerList] = useState([]);
  const [apiStatus, setApiStatus] = useState(undefined);

  const defaultFilterValues = [
    { label: "Employee", value: "" },
    { label: "Project", value: "" },
    { label: "Manager", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ];

  const [filterFormData, setFilterData] = useState([...defaultFilterValues]);

  const columns = {
    EmployeeName: { text: "Employee", align: "start", visible: "true" },
    ProjectName: { text: "Project", visible: "true", align: "start" },
    Manager: { text: "Project Manager", visible: "true", align: "start" },
    CompOffDaysApplied: { text: "Comp-Off Days Applied", visible: "true", align: "center" },
    CompOffDaysApproved: { text: "Comp-Off Days Approved", visible: "true", align: "center" },
    CompOffBalance: { text: "Current Comp-Off Balance", visible: "true", align: "center" },
  };

  const defaultColumns = {
    EmployeeName: true,
    ProjectName: true,
    Manager: true,
    CompOffDaysApplied: true,
    CompOffDaysApproved: true,
    CompOffBalance: true,
  };

  const formDatas = [
    { name: "Employee", type: "Select", options: [...empList] },
    { name: "Project", type: "Select", options: [...projectList] },
    { name: "Manager", type: "Select", options: [...managerList] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("CompOff Statement"));
    fetchCompOffStatement();
  }, []);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      if (existingLabelIndex !== -1) {
        return prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
      }
      return [
        ...prevFormData,
        { label: name, value: e.value !== undefined ? e.value : e },
      ];
    });
  };

  const fetchCompOffStatement = async (filters = filterFormData) => {
    setApiStatus(undefined)
    try {
      const employeeId = filters.find(o => o.label === "Employee")?.value || 0;
      const projectId = filters.find(o => o.label === "Project")?.value || 0;
      const managerId = filters.find(o => o.label === "Manager")?.value || 0;
      const fromDate = filters.find(o => o.label === "From Date")?.value || lastMonthDate;
      const toDate = filters.find(o => o.label === "To Date")?.value || todayDate;

      const response = await GetServiceCaller(
        `${API_URL}compOffStatement?P_EmployeeID=${employeeId}` +
        `&P_ProjectID=${projectId}` +
        `&P_LeadID=${managerId}` +
        `&P_FromDate=${moment(fromDate).format("YYYY-MM-DD")}` +
        `&P_ToDate=${moment(toDate).format("YYYY-MM-DD")}`
      );

      setApiStatus(response.status);
      if (response.status === 200) {
        setCompOffStatement(response?.data?.CompOffStatement || []);
        
        setEmpList(response?.data?.manager?.map(tech => ({
          value: tech.value,
          label: tech.text,
        })) || []);

        setProjectList(response?.data?.project?.map(tech => ({
          value: tech.value,
          label: tech.text,
        })) || []);

        setManagerList(response?.data?.manager?.map(tech => ({
          value: tech.value,
          label: tech.text,
        })) || []);

        setRepStatus(response.status);
      } else {
        console.error("Failed to fetch CompOff:", response.status);
      }
    } catch (error) {
      console.error("Error fetching CompOff:", error);
    }
  };

  const handleGetData = () => {
    fetchCompOffStatement();
  };

  const handleFilterReset = () => {
    setFilterData([...defaultFilterValues]);
    fetchCompOffStatement(defaultFilterValues);
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="row">
          <Dynamic_PR_table
            handleReset={handleFilterReset}
            data={compOffStatement}
            columns={columns}
            defaultColumns={defaultColumns}
            itemsPerPage={8}
            isSorting={true}
            // responseStatus={respStatus}
            searchTerm={searchTerm}
            isFilterRequired={true}
            setSearchTerm={setSearchTerm}
            filterFormData={filterFormData}
            formDatas={formDatas}
            handleChange={handleChange}
            handleGetData={handleGetData}
            isRequiredStatus={true}
            isApiStatus={apiStatus}
          />
        </div>
      </div>
    </div>
  );
};

export default CompOffStatement;